// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pdt {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.pdt__scroll {
  overflow-x: auto;
}

.pdt__table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  font-size: var(--fs-ui);
  color: var(--text);
}

.pdt__th {
  text-align: left;
  font-family: var(--mono);
  font-size: var(--fs-sm);
  text-transform: uppercase;
  letter-spacing: 0.14em;
  color: var(--text-muted);
  font-weight: 500;
  padding: 8px 12px;
  border-bottom: 1px solid var(--border);
  white-space: nowrap;
}

.pdt__th--sortable {
  cursor: pointer;
  user-select: none;
}

.pdt__sort {
  margin-left: 6px;
  font-size: var(--fs-micro);
  color: var(--text-muted);
}

.pdt__td {
  padding: 10px 12px;
  border-bottom: 1px solid var(--border-soft);
  vertical-align: middle;
}

.pdt__empty {
  text-align: center;
  padding: 32px;
  color: var(--text-muted);
}

.pdt__empty-title {
  font-weight: 600;
  color: var(--text);
}

.pdt__empty-desc {
  margin-top: 4px;
  font-size: var(--fs-meta);
}

.pdt__footer {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 8px 12px;
  border-top: 1px solid var(--border);
  font-size: var(--fs-meta);
  color: var(--text-muted);
}

.pdt__pagesize {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.pdt__pagesize select {
  font: inherit;
  color: var(--text);
  background: var(--bg-alt);
  border: 1px solid var(--border);
  border-radius: var(--r-data);
  padding: 2px 6px;
}

.pdt__count {
  margin-left: auto;
}

.pdt__pager {
  display: inline-flex;
  gap: 4px;
}

.pdt__pager button {
  width: 24px;
  height: 24px;
  border: 1px solid var(--border);
  background: var(--bg-alt);
  border-radius: var(--r-data);
  color: var(--text);
  cursor: pointer;
  line-height: 1;
}

.pdt__pager button:disabled {
  opacity: 0.4;
  cursor: default;
}

.pdt--loading {
  opacity: 0.6;
}
`, "",{"version":3,"sources":["webpack://./src/ui/DataTable/DataTable.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,uBAAuB;EACvB,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;EACxB,gBAAgB;EAChB,iBAAiB;EACjB,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,2CAA2C;EAC3C,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,mCAAmC;EACnC,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,+BAA+B;EAC/B,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,yBAAyB;EACzB,4BAA4B;EAC5B,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,YAAY;AACd","sourcesContent":[".pdt {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n.pdt__scroll {\n  overflow-x: auto;\n}\n\n.pdt__table {\n  width: 100%;\n  border-collapse: collapse;\n  table-layout: fixed;\n  font-size: var(--fs-ui);\n  color: var(--text);\n}\n\n.pdt__th {\n  text-align: left;\n  font-family: var(--mono);\n  font-size: var(--fs-sm);\n  text-transform: uppercase;\n  letter-spacing: 0.14em;\n  color: var(--text-muted);\n  font-weight: 500;\n  padding: 8px 12px;\n  border-bottom: 1px solid var(--border);\n  white-space: nowrap;\n}\n\n.pdt__th--sortable {\n  cursor: pointer;\n  user-select: none;\n}\n\n.pdt__sort {\n  margin-left: 6px;\n  font-size: var(--fs-micro);\n  color: var(--text-muted);\n}\n\n.pdt__td {\n  padding: 10px 12px;\n  border-bottom: 1px solid var(--border-soft);\n  vertical-align: middle;\n}\n\n.pdt__empty {\n  text-align: center;\n  padding: 32px;\n  color: var(--text-muted);\n}\n\n.pdt__empty-title {\n  font-weight: 600;\n  color: var(--text);\n}\n\n.pdt__empty-desc {\n  margin-top: 4px;\n  font-size: var(--fs-meta);\n}\n\n.pdt__footer {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding: 8px 12px;\n  border-top: 1px solid var(--border);\n  font-size: var(--fs-meta);\n  color: var(--text-muted);\n}\n\n.pdt__pagesize {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.pdt__pagesize select {\n  font: inherit;\n  color: var(--text);\n  background: var(--bg-alt);\n  border: 1px solid var(--border);\n  border-radius: var(--r-data);\n  padding: 2px 6px;\n}\n\n.pdt__count {\n  margin-left: auto;\n}\n\n.pdt__pager {\n  display: inline-flex;\n  gap: 4px;\n}\n\n.pdt__pager button {\n  width: 24px;\n  height: 24px;\n  border: 1px solid var(--border);\n  background: var(--bg-alt);\n  border-radius: var(--r-data);\n  color: var(--text);\n  cursor: pointer;\n  line-height: 1;\n}\n\n.pdt__pager button:disabled {\n  opacity: 0.4;\n  cursor: default;\n}\n\n.pdt--loading {\n  opacity: 0.6;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
